import { z } from 'zod';

const EdgeConfigSchema = z.object({
  edgeConfig: z
    .string({
      error: (issue) =>
        issue.input === undefined
          ? 'EDGE_CONFIG environment variable is required'
          : 'EDGE_CONFIG must be a string',
    })
    .min(1, 'EDGE_CONFIG cannot be empty'),
  vercelToken: z
    .string({
      error: (issue) =>
        issue.input === undefined
          ? 'VERCEL_ACCESS_TOKEN environment variable is required'
          : 'VERCEL_ACCESS_TOKEN must be a string',
    })
    .min(1, 'VERCEL_ACCESS_TOKEN cannot be empty'),
  edgeConfigId: z
    .string({
      error: (issue) =>
        issue.input === undefined
          ? 'EDGE_CONFIG_ID environment variable is required'
          : 'EDGE_CONFIG_ID must be a string',
    })
    .min(1, 'EDGE_CONFIG_ID cannot be empty'),
  teamId: z
    .string({
      error: (issue) =>
        issue.input === undefined
          ? 'TEAM_ID environment variable is required'
          : 'TEAM_ID must be a string',
    })
    .min(1, 'TEAM_ID cannot be empty'),
});

export type EdgeConfigSettings = z.infer<typeof EdgeConfigSchema>;

export function getEdgeConfiguration(config?: Partial<EdgeConfigSettings>) {
  const edgeConfig = {
    edgeConfig: config?.edgeConfig ?? process.env.EDGE_CONFIG,
    vercelToken: config?.vercelToken ?? process.env.VERCEL_ACCESS_TOKEN,
    edgeConfigId: config?.edgeConfigId ?? process.env.EDGE_CONFIG_ID,
    teamId: config?.teamId ?? process.env.TEAM_ID,
  };

  try {
    return EdgeConfigSchema.parse(edgeConfig);
  } catch (error) {
    console.error('Validation failed:', error);
    throw error;
  }
}
